import React from 'react'
import { Paper, Typography } from '@the-platform-group/component-library'

const JobMapHeader = ({ title }) => {
  return (
    <Paper sx={{ p: 1, bgcolor: 'background.secondary.default' }} elevation={0}>
      <Typography variant="subtitle2" fontWeight="bold">
        {title}
      </Typography>
    </Paper>
  )
}

export default JobMapHeader
